import { react2angular } from 'react2angular';
import { EventHistoryTable } from './EventHistoryTable';

angular
  .module('webtip.module')
  .component('mrtEventHistoryTable', react2angular(EventHistoryTable, [
    'eventHistory',
    'selectedEnvData',
    'environmentColumns',
    'loadBusy',
    'hasMore',
    'isActive',
    'usesAlternateEventDisplay',
    'usesQualifierEventColor',
    'showsActiveCarLabel',
    'supportsAlarmAnalytics',
    'sortType',
    'sortReverse',
    'onLoadMore',
    'onExportExcel',
    'onExportCsv',
  ], ['formatTimestampFilter']));
